import { render, staticRenderFns } from "./CustomerMaintainence.vue?vue&type=template&id=7dfaad48"
import script from "./CustomerMaintainence.vue?vue&type=script&lang=js"
export * from "./CustomerMaintainence.vue?vue&type=script&lang=js"
import style0 from "./CustomerMaintainence.vue?vue&type=style&index=0&id=7dfaad48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.44_cache-loader@4.1.0_webpack@4.47.0__css-load_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports